import React from 'react'
import {connect} from 'react-redux'
import {Form, Control, Errors, actions,} from 'react-redux-form'
import {Row, Col, FormGroup, ControlLabel, Radio, Checkbox} from 'react-bootstrap'
import RequiredSelect from '../../../../common/form/elements/required-select'
import ImageUpload from "../../../../common/form/elements/image-upload";
import RequiredInput from '../../../../common/form/elements/required-input'
import RequiredDatePicker from '../../../../common/form/elements/required-datepicker'
import MultiSelect from '../../../../common/form/multi-select';
import DatePicker from '../../../../common/form/datepicker'
import ArrowButton from '../../../../common/button-arrow'
import SectionTitle from '../../../../common/section-title/index';
import {saveArticle, updateArticle} from '../../../../../actions/news'
import GroupMultiSelect from '../../../../common/groups/group-multi-select'
import classnames from "classnames";

class EditArticleForm extends React.Component {

  state = {
    isRewardStore: undefined,
  };

  generatePermissions(permissions) {
    if (permissions.length) {
      return (
        permissions.map((perm, index) => {
            return (
              <FormGroup key={`perm-group-${index}`}
                         className="permission-block">
                <b>{perm.name}</b>
                {
                  perm.children.map((child, index) => {
                    return <Control.checkbox key={`perm-${index}`}
                                             model={`.permission_ids[${child.id}].checked`}
                                             onChange={event => this.handlePermissionChange(event.target.checked, child.name)}
                                             component={Checkbox}>{child.name}</Control.checkbox>
                  })
                }
              </FormGroup>
            )
          }
        )
      )
    }
  };

  handlePermissionChange(value, name) {
    const {dispatch} = this.props;

    if (name === 'Reward Store') {
      this.setState({isRewardStore: value}, () => {
        if (value === false) {
          dispatch(actions.setValidity('deep.admin_news.article.group_ids', true));
        } else {
          dispatch(actions.resetValidity('deep.admin_news.article.group_ids'));
        }
      });
    }
  }

  onSubmit(payLoad) {
    const {dispatch, article} = this.props;
    if (article.id) {
      dispatch(actions.submitFields('deep.admin_news.article', updateArticle(article.id, payLoad)));
    } else {
      dispatch(actions.submitFields('deep.admin_news.article', saveArticle(payLoad)));
    }
  };

  isRewardStoreDefault = (permissions) => {
    if (!Array.isArray(permissions) || permissions.length === 0) return false;
    return permissions
      .find(p => p.name === 'Stores').children
      .find(p => p.name === "Reward Store").checked
  };

  render() {
    const {article, ...props} = this.props;
    const {isRewardStore} = this.state;

    let image = undefined,
      displayFromDate = '',
      displayToDate = '',
      linkedArticles = [],
      permissions = props.permissions,
      groupIds = [],
      all = false;

    const attributes = article.attributes;

    if (attributes) {
      image = attributes.link ? attributes.link.image : undefined;
      displayFromDate = attributes['display-from-date'];
      displayToDate = attributes['display-to-date'];
      linkedArticles = attributes['linked-articles'];
      groupIds = attributes['group-ids'];
      all = attributes['all-groups'];
      permissions = attributes.permissions;
    }

    const hideGroups = !(isRewardStore === undefined ? this.isRewardStoreDefault(permissions) : isRewardStore);

    return (
      <Form model="deep.admin_news.article"
            onSubmit={this.onSubmit.bind(this)}
            validators={{
              '': {
                featured: (vals) => vals.featured
              }
            }}>
        <Row className="pull-right">
          <Col lg={12}>
            <ArrowButton arrow={false}
                         className="pull-right"
                         disabled={!props.formValid}>Save</ArrowButton>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput label="Title"
                           placeholder="Title"
                           model='.title'
                           controlId='title'/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredSelect model=".news_category_id"
                            values={props.categoryList}
                            labelAttr='attributes.name'
                            valueAttr='id'
                            label="Category"
                            controlId="newsCategory"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload source={image}
                         sizeLimit={1024 * 1024}
                         type={['image/png', 'image/jpg', 'image/jpeg']}
                         model=".image"
                         required/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredSelect model=".status"
                            values={props.statusList}
                            label="Status"
                            controlId="brandCategory"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredDatePicker model="deep.admin_news.article.display_from_date"
                                value={displayFromDate}
                                label="Display from date"
                                placeholder="Select a date..."
                                timeFormat="HH:mm"
                                controlId="displayFromDate"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <DatePicker model="deep.admin_news.article.display_to_date"
                        value={displayToDate}
                        timeFormat="HH:mm"
                        placeholder="Select a date..."
                        label="Display to date"/>
          </Col>
        </Row>


        <Row>
          <Col lg={12}>
            <FormGroup>
              <ControlLabel>Featured article</ControlLabel>
              <br/>

              <Control.radio model=".featured"
                             value="true"
                             inline
                             component={Radio}>Yes</Control.radio>

              <Control.radio model=".featured"
                             value="false"
                             inline
                             component={Radio}>No</Control.radio>

              <Errors show={{touched: true}}
                      className="errors"
                      model="deep.admin_news.article"
                      messages={{featured: 'You must set featured state.'}}/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <SectionTitle>Article permissions {hideGroups.toString()}</SectionTitle>
            <div className={classnames({hidden: hideGroups})}>
              <GroupMultiSelect
                model={"deep.admin_news.article.group_ids"}
                value={groupIds}
                all={all}
                required={!hideGroups}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {this.generatePermissions(permissions)}
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <MultiSelect data={props.linkArticles}
                         value={linkedArticles}
                         labelAttr="title"
                         valueAttr="id"
                         model="deep.admin_news.article.linked_article_ids"
                         label="Linked articles"
                         controlId="linkedArticles"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton arrow={false}
                         className="pull-right"
                         disabled={!props.formValid}>Save</ArrowButton>
          </Col>
        </Row>
      </Form>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.admin_news.article.$form.valid,
  };
};

export default connect(mapStateToProps)(EditArticleForm);




// WEBPACK FOOTER //
// ./src/components/admin/news/articles/edit/article-edit-form.jsx